/**
 * Конфигурация приложения Nuxt UI
 * Определяет цветовую схему и другие настройки UI компонентов
 */
export default defineAppConfig({
  ui: {
    colors: {
      // Основной цвет приложения
      primary: "green",
      // Нейтральный цвет
      neutral: "slate",
    },
  },
});
